import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import { Container, Grid, Box, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Moment from 'react-moment'
import Cancel from '@material-ui/icons/Cancel'
import moment from 'moment'

import HomepageHeaderComponent from './HomepageHeaderComponent'
import HomeDemographicsComponent from './HomeDemographicsComponent'
import HomePortfolioComponent from './HomePortfolioComponent'
import HomeBrandEngagerGenreProfileComponent from './HomeBrandEngagerGenreProfileComponent'
import HomeViewershipOverlapComponent from './HomeViewershipOverlapComponent'
import HomeGenreInterestComponent from './HomeGenreInterestComponent'
import HomePageOnBoarding from './HomePageOnBoarding'
import Spinner from '../Spinner'
import NotFound from '../NotFound'

import { theme } from '../../classes/Themes'
import { styles } from '../../classes/Styles'

import './HomepageComponent.scss'
import { HOMEPAGE_GENRE_PROFILE, HOMEPAGE_GENRE_INTEREST } from '../../constants/commons'

class HomepageComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    topic: PropTypes.object,
    topicId: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    demographics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    whatsNew: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    topShows: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    trendingVideos: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    anticipatedShows: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    })

  }

  constructor (props) {
    super(props)

    this.state = {
      hideShortcutBanner: false,
      screenWidth: window.innerWidth,
      genreProfHeightRef: 295,
      genreIntHeightRef: 290,
      selectedGenreModule: HOMEPAGE_GENRE_PROFILE,
      selectedGenreChartModule: ''
    }
    this.scrollRef = React.createRef()
    this.genreProfHeightRef = React.createRef()
    this.genreIntHeightRef = React.createRef()
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    if ((this.props.anticipatedShows && this.props.anticipatedShows.details) || (this.props.metrics && this.props.metrics.details)) {
      this.updateModuleHeight()
    }
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.anticipatedShows != this.props.anticipatedShows && this.props.anticipatedShows.details) || (prevProps.metrics != this.props.metrics && this.props.metrics.details)) {
      this.updateModuleHeight()
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
    if (window.innerWidth >= 1024) {
      this.updateModuleHeight()
    }
  }

  updateModuleHeight = () => {
    if ((this.props.metrics && this.props.metrics.details)) {
      const genreProf = this.genreProfHeightRef.current && this.genreProfHeightRef.current.clientHeight
      this.setState({ genreProfHeightRef: genreProf })
    }
    if ((this.props.anticipatedShows && this.props.anticipatedShows.details) || (this.props.metrics && this.props.metrics.details)) {
      const genreInt = this.genreIntHeightRef.current && this.genreIntHeightRef.current.clientHeight
      this.setState({ genreIntHeightRef: genreInt })
    }
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const topicName = this.props.topic.details && (this.props.topic.details.display_name || this.props.topic.details.name)
    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for <strong>{topicName}</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    const topic = this.props.topic && this.props.topic.details
    const topicName = topic && topic.display_name ? topic.display_name : topic && topic.name ? topic.name : ''
    if (!this.props.shortcut) {
      return null
    }
    const name = 'Home Page Tour'
    return (
      <HomePageOnBoarding
        name={name}
        run={true}
        setScroll={this._setScroll.bind(this)}
        homepage={topicName}
        />
    )
  }

  _setScroll () {
    window.scrollTo({
      top: this.scrollRef.current.offsetTop + 200
    })
  }

  currentYear () {
    let currentMonth = moment().format('MMMM');
    let currentYear = moment().format('YYYY');
    let PrevYear = moment (currentYear, 'YYYY').subtract(1, 'years').format('YYYY');
    if (currentMonth === 'January') {
      return PrevYear
    } else {
      return currentYear
    }
  }

  prevMonth () {
    let currentMonth = moment().format('MMMM');
    let prevMonth = moment (currentMonth, 'MMMM').subtract(1, 'months').format('MMMM');
    return prevMonth
  }

  render () {
    if (this.props.topic.error) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    if (this.props.topic.isFetching) {
      return (<Spinner />)
    }

    const { classes, homepage, topic } = this.props
    const homepageName = topic.details && (topic.details.display_name || topic.details.name)

    const handleGenreModuleChange = () => {
      const selectedGenreModule = this.state.selectedGenreModule === HOMEPAGE_GENRE_PROFILE ? HOMEPAGE_GENRE_INTEREST : HOMEPAGE_GENRE_PROFILE
      this.setState({
        selectedGenreModule: selectedGenreModule,
        selectedGenreChartModule: selectedGenreModule
      })
    }
    return (
      <ThemeProvider theme={theme}>
        <div className="rightSide homepage" ref={this.scrollRef}>
          <Container maxWidth="xl" className={classes.containerRoot}>
            {this._renderShortcut()}
            {this._renderOnboarding ()}
            <HomepageHeaderComponent
              homepage={homepage}
              topic={topic}
              history={this.props.history}
              shortcut={this.props.shortcut}/>
            <Box className="dateTxt">
              <Typography>Data for {this.prevMonth()} {this.currentYear()}</Typography>
            </Box>
            <Grid container spacing={1} alignItems="stretch" direction='row' justify="center" id='engangementComp'>
              <Grid item xs={12} lg={6} md={12} sm={12} className='modulePadding'
                style={{transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
              })}}>
                <HomePortfolioComponent
                  homepage={homepageName}
                  engagementNetwork={this.props.metrics}
                  screenWidth={this.state.screenWidth}
                  topicId={this.props.topicId}
                />
              </Grid>
              <Grid item xs={12} lg={6} md={12} sm={12} className='modulePadding'
                style={{transition: theme.transitions.create('all', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen
              })}}>
                <HomeDemographicsComponent
                  homepage={homepageName}
                  demographics={this.props.demographics}
                  screenWidth={this.state.screenWidth}
                  />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Grid container spacing={1} id='genreComp'>
                  <Grid item xs={12} lg={12} md={12} sm={12} className='navModulePadding' ref={this.genreProfHeightRef}
                    >
                    { this.state.selectedGenreModule === HOMEPAGE_GENRE_PROFILE &&
                      <HomeBrandEngagerGenreProfileComponent
                        homepage={homepageName}
                        metrics={this.props.metrics}
                        screenWidth={this.state.screenWidth}
                        handleGenreModuleChange={handleGenreModuleChange}
                        selectedGenreChartModule={this.state.selectedGenreChartModule}
                      />
                    }
                    { this.state.selectedGenreModule === HOMEPAGE_GENRE_INTEREST &&
                      <HomeGenreInterestComponent
                        homepage={homepageName}
                        metrics={this.props.metrics}
                        screenWidth={this.state.screenWidth}
                        handleGenreModuleChange={handleGenreModuleChange}
                      />
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Grid container spacing={1} id='trendingComp'>
                  <Grid item xs={12} lg={12} md={12} sm={12} className='navModulePadding viewershipOverlap'
                    style={{maxHeight: this.state.genreProfHeightRef, minHeight: this.state.genreProfHeightRef}}>
                    <HomeViewershipOverlapComponent
                      homepage={homepageName}
                      metrics={this.props.metrics}
                      screenWidth={this.state.screenWidth}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
      </ThemeProvider>
    )
  }
}

export default withStyles(styles)(HomepageComponent)